import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { role } from "../Roles/RolesSlice";

// Models
export interface user {
    id: number;
    employee: { id: number; name: string; };
    name?: string;
    email?: string;
    password?: string;
    role?: role;
}

// Users state
export interface usersState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    users: user[]
}

const initialUsersState: usersState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    users: []
}

// Users slice
export const usersSlice = createSlice({
    name: 'users',
    initialState: initialUsersState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        addUsers: ( state, {payload}: PayloadAction<user[]> ) => {
            state.users = [ ...state.users, ...payload ]
        },
        updateUser: ( state, {payload}: PayloadAction<user> ) => {
            let index = state.users.findIndex( user => user.id === payload.id )
            if( index !== -1 )
                state.users[index] = payload
        },
        deleteUsers: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.users.findIndex( user => user.id === id )
                if( index != -1 )
                    state.users.splice( index, 1 )
            })
        },
        reset: ( state ) => {
            state.users = []
            state.hasMore = true
        }
    }
})